import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';

import {
  GetEndpointQuery,
  GetEndpointResponse,
} from '@hud/portal-dtos/webapp-endpoint.dto';
import { AxiosError } from 'axios';
import { ErrorResponse } from '@hud/portal-dtos/webapp-common.dto';
import { PORTAL_BASE } from '../consts';

export const ENDPOINT_ID = 'endpoint';

export default function useEndpoint(
  endpointId?: number,
  serviceId?: number,
  params?: GetEndpointQuery,
) {
  const { client, isReady } = useClient();
  return useQuery<GetEndpointResponse, AxiosError<ErrorResponse>>({
    queryKey: [ENDPOINT_ID, endpointId, params],
    queryFn: async () => {
      const response = await client.get<GetEndpointResponse>(
        `${PORTAL_BASE}/endpoints/${endpointId}-${serviceId}`,
        { params },
      );
      return GetEndpointResponse.parse(response.data);
    },
    enabled: endpointId !== undefined && serviceId !== undefined && isReady,
    retry: (failureCount, error) => {
      if (
        error?.response?.status &&
        error.response.status > 401 &&
        error.response.status < 500
      ) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
